











































import axios from "axios";
import Fact, {
  FactRecordHolder,
  getParkingLotFactByID,
  convertParkingLotFactToFact,
} from "@/models/Fact";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class DocumentParkingLotFactsTable extends Vue {
  @Prop({ type: Number }) id!: number;
  @Prop({ type: Boolean }) active!: boolean;

  private facts: FactRecordHolder[] = [];
  private loading: boolean = false;
  private error: boolean = false;

  private headers: object[] = [
    { text: "Figure", value: "figure" },
    { text: "Unit", value: "unit" },
    { text: "Term", value: "term" },
    { text: "Country", value: "country" },
    { text: "Excerpt", value: "excerpt" },
    { text: "Actions", value: "name", sortable: false },
  ];

  async created() {
    if (!!this.id) {
      await this.loadFacts();
    }
  }

  async loadFacts() {
    this.loading = true;
    try {
      let response = await axios.get("/psql/parking_lot", {
        params: {
          type: "eq.facts",
          pid: `eq.${this.id}`,
          status: "eq.waiting",
        },
      });

      this.facts = response.data.map((record: any) => {
        let fact = convertParkingLotFactToFact(record.data);
        return {
          id: record.id,
          parkingLot: true,
          data: fact,
        };
      });
    } catch (error) {
      console.error(error);
      console.error(error.response);
      this.error = true;
    }
    this.loading = false;
  }

  async loadFact(id: number) {
    this.$emit("loadingFact", true);
    try {
      let response = await getParkingLotFactByID(id);
      let data = response.data.data;
      let fact = convertParkingLotFactToFact(data);
      this.$emit("factLoaded", {
        id,
        parkingLot: true,
        data: fact,
      });
      this.$toast.success("Parking lot fact is loaded");
    } catch (error) {
      console.error(error);
      console.error(error.response);
      this.$toast.error("Failed to load parking lot fact");
    }
    this.$emit("loadingFact", false);
  }

  async rejectFact(id: number) {
    this.loading = true;
    try {
      let response = await axios.post(
        "/psql/rpc/helix_reject_parking_lot_record",
        { pl_id: id }
      );
      this.facts = this.facts.filter((fact: any) => fact.id !== id);
      this.$toast.success("Fact rejected");
    } catch (error) {
      console.error(error.response);
      this.$toast.error("Failed to reject fact");
    }
    this.loading = false;
  }
}
